import { Property } from 'csstype';
import styles from './ColorMarker.module.scss';

interface Props {
  color: Property.BackgroundColor | undefined;
}

export function ColorMarker(props: Props) {
  const { color } = props;
  return (
    <div
      className={styles.colorMarker}
      style={{
        backgroundColor: color,
      }}
    />
  );
}
